var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSale2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8489",
    "data-name": "Group 8489",
    transform: "translate(-1691.803 -351.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 20,
    height: 20,
    transform: "translate(1691.803 351.41)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1714.639,429.231h-6.9v-3.162h-3.51v3.162h-6.9a.5.5,0,1,0,0,1.007h17.311a.5.5,0,1,0,0-1.007Z",
    transform: "translate(-4.01 -59.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1769.629,404.561l-5.3-1.821,1.267,3.381.676,1.8.974-1.5,1.8,1.5.582-.526-1.558-1.682Z",
    transform: "translate(-57.92 -40.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8488",
    "data-name": "Group 8488",
    transform: "translate(1693.113 353.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1726.8,396.278h.851l.125-.594h-1.01Z",
    transform: "translate(-1721.039 -389.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1719.24,395.684l.159.594h.607l-.034-.594Z",
    transform: "translate(-1715.025 -389.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1716.616,380.77h-1.362l.075.279a.371.371,0,0,1,.009.045l.094.35h1.222Z",
    transform: "translate(-1711.842 -377.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1726.372,388.766h1.219l.16-.764h-1.423Z",
    transform: "translate(-1720.686 -383.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1718.239,388h-1.058l.2.764h.9Z",
    transform: "translate(-1713.381 -383.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1735.138,396.278h.831l.265-.594h-.972Z",
    transform: "translate(-1727.723 -389.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1711.6,370.521a.8.8,0,0,1,.261.044l4.166,1.43V364.52a1.113,1.113,0,0,0-1.112-1.113h-15.5a1.113,1.113,0,0,0-1.113,1.113v9.075a1.113,1.113,0,0,0,1.113,1.112h12.588l-1.161-3.1a.805.805,0,0,1,.754-1.088Zm-8.634,3.106a.876.876,0,1,1,.876-.876A.877.877,0,0,1,1702.967,373.628Zm3.193,0a.876.876,0,1,1,.876-.876A.877.877,0,0,1,1706.16,373.628Zm2.963-6.957-1.338,3h0l-.618,1.383a.392.392,0,0,1-.357.232h-4.427a.392.392,0,0,1-.378-.29l-1.174-4.38c0-.007,0-.015,0-.022l-.518-1.479h-.376a.391.391,0,0,1,0-.783h.676a.392.392,0,0,1,.378.289l.525,1.5h7.257a.392.392,0,0,1,.357.551Zm1.62,2.181.292-.665a1.936,1.936,0,0,0,1.075.322q.563,0,.563-.358a.241.241,0,0,0-.153-.228,2.849,2.849,0,0,0-.507-.161,4.624,4.624,0,0,1-.624-.2,1.113,1.113,0,0,1-.427-.317.866.866,0,0,1-.182-.578.976.976,0,0,1,.286-.7,1.42,1.42,0,0,1,.757-.394v-.583h.716v.563a2.631,2.631,0,0,1,.552.136,1.4,1.4,0,0,1,.414.228l-.292.665a2.2,2.2,0,0,0-.5-.243,1.553,1.553,0,0,0-.486-.084.679.679,0,0,0-.376.092.294.294,0,0,0-.141.261.252.252,0,0,0,.09.2.619.619,0,0,0,.223.123c.089.029.215.064.379.1a4.543,4.543,0,0,1,.614.184,1.013,1.013,0,0,1,.42.312.893.893,0,0,1,.174.578.975.975,0,0,1-.284.706,1.4,1.4,0,0,1-.765.384v.578h-.716v-.558a2.553,2.553,0,0,1-.611-.12A1.786,1.786,0,0,1,1710.742,368.852Z",
    transform: "translate(-1698.308 -363.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1725.949,381.443h1.632l.141-.674h-1.812Z",
    transform: "translate(-1720.353 -377.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1738.181,381.443h1.524l.3-.674h-1.684Z",
    transform: "translate(-1730.153 -377.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M1736.572,388.766h1.157l.341-.764h-1.339Z",
    transform: "translate(-1728.867 -383.05)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSale2);
export default __webpack_public_path__ + "static/media/white_sale2.c5d2b0930bde18c591d68be53d8b9881.svg";
export { ForwardRef as ReactComponent };